/**
 * Scheuch Process Designer
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext,
} from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { SeuApiInterconnection } from '../model/interconnection';
// @ts-ignore
import { SeuApiOperatingCondition } from '../model/operatingCondition';
// @ts-ignore
import { SeuApiSaveInputStreamDto } from '../model/saveInputStreamDto';
// @ts-ignore
import { SeuApiSaveInputStreamValuesDto } from '../model/saveInputStreamValuesDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { SeuApiConfiguration } from '../configuration';
import { BaseService } from '../api.base.service';

export interface CreateInputStreamRequestParams {
  /** The id of the offer to which the interconnection belongs */
  offerId: string;
  /** The id of the interconnection to which the input stream belongs */
  interconnectionId: number;
  seuApiSaveInputStreamDto: SeuApiSaveInputStreamDto;
}

export interface DeleteInputStreamRequestParams {
  /** The id of the offer to which the interconnection belongs */
  offerId: string;
  /** The id of the interconnection to which the inputstream belongs */
  interconnectionId: number;
  /** The id of the input stream to delete */
  inputStreamId: string;
}

export interface DuplicateInputStreamRequestParams {
  /** The id of the offer to which the interconnection belongs */
  offerId: string;
  /** The id of the interconnection to which the input stream belongs */
  interconnectionId: number;
  /** The id of the input stream to duplicate */
  inputStreamId: string;
}

export interface UpdateInputStreamRequestParams {
  /** The id of the offer to which the interconnection belongs */
  offerId: string;
  /** The id of the interconnection to which the inputstream belongs */
  interconnectionId: number;
  /** The id of the input stream to update */
  inputStreamId: string;
  seuApiSaveInputStreamDto: SeuApiSaveInputStreamDto;
}

export interface UpdateOperatingConditionInputStreamValuesRequestParams {
  /** The id of the offer to which the interconnection belongs */
  offerId: string;
  /** The id of the interconnection to which the inputstream belongs */
  interconnectionId: number;
  /** The id of the operating condition to which the input stream values belong */
  operatingConditionId: number;
  /** The id of the input stream to update the values for */
  inputStreamId: string;
  seuApiSaveInputStreamValuesDto: SeuApiSaveInputStreamValuesDto;
}

@Injectable({
  providedIn: 'root',
})
export class InputStreamRestControllerApiService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: SeuApiConfiguration
  ) {
    super(basePath, configuration);
  }

  /**
   * @endpoint post /offers/{offerId}/interconnections/{interconnectionId}/inputStreams
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createInputStream(
    requestParameters: CreateInputStreamRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeuApiInterconnection>;
  public createInputStream(
    requestParameters: CreateInputStreamRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeuApiInterconnection>>;
  public createInputStream(
    requestParameters: CreateInputStreamRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeuApiInterconnection>>;
  public createInputStream(
    requestParameters: CreateInputStreamRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const offerId = requestParameters?.offerId;
    if (offerId === null || offerId === undefined) {
      throw new Error(
        'Required parameter offerId was null or undefined when calling createInputStream.'
      );
    }
    const interconnectionId = requestParameters?.interconnectionId;
    if (interconnectionId === null || interconnectionId === undefined) {
      throw new Error(
        'Required parameter interconnectionId was null or undefined when calling createInputStream.'
      );
    }
    const seuApiSaveInputStreamDto =
      requestParameters?.seuApiSaveInputStreamDto;
    if (
      seuApiSaveInputStreamDto === null ||
      seuApiSaveInputStreamDto === undefined
    ) {
      throw new Error(
        'Required parameter seuApiSaveInputStreamDto was null or undefined when calling createInputStream.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (bearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'bearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer '
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/offers/${this.configuration.encodeParam({ name: 'offerId', value: offerId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/interconnections/${this.configuration.encodeParam({ name: 'interconnectionId', value: interconnectionId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}/inputStreams`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<SeuApiInterconnection>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seuApiSaveInputStreamDto,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * @endpoint delete /offers/{offerId}/interconnections/{interconnectionId}/inputStreams/{inputStreamId}
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteInputStream(
    requestParameters: DeleteInputStreamRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeuApiInterconnection>;
  public deleteInputStream(
    requestParameters: DeleteInputStreamRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeuApiInterconnection>>;
  public deleteInputStream(
    requestParameters: DeleteInputStreamRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeuApiInterconnection>>;
  public deleteInputStream(
    requestParameters: DeleteInputStreamRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const offerId = requestParameters?.offerId;
    if (offerId === null || offerId === undefined) {
      throw new Error(
        'Required parameter offerId was null or undefined when calling deleteInputStream.'
      );
    }
    const interconnectionId = requestParameters?.interconnectionId;
    if (interconnectionId === null || interconnectionId === undefined) {
      throw new Error(
        'Required parameter interconnectionId was null or undefined when calling deleteInputStream.'
      );
    }
    const inputStreamId = requestParameters?.inputStreamId;
    if (inputStreamId === null || inputStreamId === undefined) {
      throw new Error(
        'Required parameter inputStreamId was null or undefined when calling deleteInputStream.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (bearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'bearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer '
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/offers/${this.configuration.encodeParam({ name: 'offerId', value: offerId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/interconnections/${this.configuration.encodeParam({ name: 'interconnectionId', value: interconnectionId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}/inputStreams/${this.configuration.encodeParam({ name: 'inputStreamId', value: inputStreamId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<SeuApiInterconnection>(
      'delete',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Duplicates an input stream on every operating condition of the interconnection
   * E.g. you have OC1 and OC2 + IS1 and IS2 with values between each of them. It does differentiate between OCs. If you duplicate IS1, this will create: - IS3 - Values of IS1 on OC1 - Values of IS1 on OC2
   * @endpoint post /offers/{offerId}/interconnections/{interconnectionId}/inputStreams/{inputStreamId}
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public duplicateInputStream(
    requestParameters: DuplicateInputStreamRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeuApiInterconnection>;
  public duplicateInputStream(
    requestParameters: DuplicateInputStreamRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeuApiInterconnection>>;
  public duplicateInputStream(
    requestParameters: DuplicateInputStreamRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeuApiInterconnection>>;
  public duplicateInputStream(
    requestParameters: DuplicateInputStreamRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const offerId = requestParameters?.offerId;
    if (offerId === null || offerId === undefined) {
      throw new Error(
        'Required parameter offerId was null or undefined when calling duplicateInputStream.'
      );
    }
    const interconnectionId = requestParameters?.interconnectionId;
    if (interconnectionId === null || interconnectionId === undefined) {
      throw new Error(
        'Required parameter interconnectionId was null or undefined when calling duplicateInputStream.'
      );
    }
    const inputStreamId = requestParameters?.inputStreamId;
    if (inputStreamId === null || inputStreamId === undefined) {
      throw new Error(
        'Required parameter inputStreamId was null or undefined when calling duplicateInputStream.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (bearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'bearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer '
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/offers/${this.configuration.encodeParam({ name: 'offerId', value: offerId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/interconnections/${this.configuration.encodeParam({ name: 'interconnectionId', value: interconnectionId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}/inputStreams/${this.configuration.encodeParam({ name: 'inputStreamId', value: inputStreamId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<SeuApiInterconnection>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * @endpoint put /offers/{offerId}/interconnections/{interconnectionId}/inputStreams/{inputStreamId}
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateInputStream(
    requestParameters: UpdateInputStreamRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeuApiInterconnection>;
  public updateInputStream(
    requestParameters: UpdateInputStreamRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeuApiInterconnection>>;
  public updateInputStream(
    requestParameters: UpdateInputStreamRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeuApiInterconnection>>;
  public updateInputStream(
    requestParameters: UpdateInputStreamRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const offerId = requestParameters?.offerId;
    if (offerId === null || offerId === undefined) {
      throw new Error(
        'Required parameter offerId was null or undefined when calling updateInputStream.'
      );
    }
    const interconnectionId = requestParameters?.interconnectionId;
    if (interconnectionId === null || interconnectionId === undefined) {
      throw new Error(
        'Required parameter interconnectionId was null or undefined when calling updateInputStream.'
      );
    }
    const inputStreamId = requestParameters?.inputStreamId;
    if (inputStreamId === null || inputStreamId === undefined) {
      throw new Error(
        'Required parameter inputStreamId was null or undefined when calling updateInputStream.'
      );
    }
    const seuApiSaveInputStreamDto =
      requestParameters?.seuApiSaveInputStreamDto;
    if (
      seuApiSaveInputStreamDto === null ||
      seuApiSaveInputStreamDto === undefined
    ) {
      throw new Error(
        'Required parameter seuApiSaveInputStreamDto was null or undefined when calling updateInputStream.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (bearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'bearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer '
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/offers/${this.configuration.encodeParam({ name: 'offerId', value: offerId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/interconnections/${this.configuration.encodeParam({ name: 'interconnectionId', value: interconnectionId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}/inputStreams/${this.configuration.encodeParam({ name: 'inputStreamId', value: inputStreamId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<SeuApiInterconnection>(
      'put',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seuApiSaveInputStreamDto,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * @endpoint put /offers/{offerId}/interconnections/{interconnectionId}/operatingCondition/{operatingConditionId}/inputStreams/{inputStreamId}
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateOperatingConditionInputStreamValues(
    requestParameters: UpdateOperatingConditionInputStreamValuesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeuApiOperatingCondition>;
  public updateOperatingConditionInputStreamValues(
    requestParameters: UpdateOperatingConditionInputStreamValuesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeuApiOperatingCondition>>;
  public updateOperatingConditionInputStreamValues(
    requestParameters: UpdateOperatingConditionInputStreamValuesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeuApiOperatingCondition>>;
  public updateOperatingConditionInputStreamValues(
    requestParameters: UpdateOperatingConditionInputStreamValuesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const offerId = requestParameters?.offerId;
    if (offerId === null || offerId === undefined) {
      throw new Error(
        'Required parameter offerId was null or undefined when calling updateOperatingConditionInputStreamValues.'
      );
    }
    const interconnectionId = requestParameters?.interconnectionId;
    if (interconnectionId === null || interconnectionId === undefined) {
      throw new Error(
        'Required parameter interconnectionId was null or undefined when calling updateOperatingConditionInputStreamValues.'
      );
    }
    const operatingConditionId = requestParameters?.operatingConditionId;
    if (operatingConditionId === null || operatingConditionId === undefined) {
      throw new Error(
        'Required parameter operatingConditionId was null or undefined when calling updateOperatingConditionInputStreamValues.'
      );
    }
    const inputStreamId = requestParameters?.inputStreamId;
    if (inputStreamId === null || inputStreamId === undefined) {
      throw new Error(
        'Required parameter inputStreamId was null or undefined when calling updateOperatingConditionInputStreamValues.'
      );
    }
    const seuApiSaveInputStreamValuesDto =
      requestParameters?.seuApiSaveInputStreamValuesDto;
    if (
      seuApiSaveInputStreamValuesDto === null ||
      seuApiSaveInputStreamValuesDto === undefined
    ) {
      throw new Error(
        'Required parameter seuApiSaveInputStreamValuesDto was null or undefined when calling updateOperatingConditionInputStreamValues.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (bearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'bearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer '
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/offers/${this.configuration.encodeParam({ name: 'offerId', value: offerId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/interconnections/${this.configuration.encodeParam({ name: 'interconnectionId', value: interconnectionId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}/operatingCondition/${this.configuration.encodeParam({ name: 'operatingConditionId', value: operatingConditionId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}/inputStreams/${this.configuration.encodeParam({ name: 'inputStreamId', value: inputStreamId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<SeuApiOperatingCondition>(
      'put',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seuApiSaveInputStreamValuesDto,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress,
      }
    );
  }
}
